<template>
  <v-row class="app-preview">
    <v-col
      cols="12"
      md="9"
    >
      <v-card class="app-loyalty-editable">
        <!-- Header -->
        <div class="py-5 px-5">
          <div class="d-flex flex-wrap justify-space-between">
            <!-- Date -->
            <div class="d-flex align-center">
              <span class="me-2 font-weight-medium text--primary">Edit Niagamas Loyalty</span>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Customer Details -->
        <div class="py-5 px-5">
          <div class="mb-3 d-flex">
            <div class="px-3 flex-grow-1">
              <v-row>
                <!-- Registration Date -->
                <v-col
                  cols="12"
                  sm="6"
                  :class="{ 'pl-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                >
                  <p class="font-weight-semibold">
                    Registration Date:
                  </p>
                  <v-menu
                    v-model="isDateMenuOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :append-icon="icons.mdiCalendar"
                        :value="new Date(loyalty.registration_date).toLocaleDateString()"
                        readonly
                        dense
                        outlined
                        hide-details
                        :disabled="auditorDisabled || voidRequestDisabled || isApprovedRequest"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="loyalty.registration_date"
                      color="primary"
                      :first-day-of-week="1"
                      @input="isDateMenuOpen = false"
                    >
                    </v-date-picker>
                  </v-menu>
                  <RequestHint
                    v-if="request && !isApprovedRequest"
                    :is-attr-change="loyalty.registration_date !== request.registration_date"
                    :is-auditor-respond="auditorDisabled"
                    :is-request-void="isRequestVoid"
                    :hint="new Date(request.registration_date).toLocaleDateString('en-SG')"
                  />
                </v-col>

                <!-- Loyalty Type -->
                <v-col
                  cols="12"
                  sm="6"
                  :class="{ 'pr-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                >
                  <p class="font-weight-semibold payment-details-header">
                    Loyalty Type:
                  </p>
                  <v-select
                    v-model="loyalty.loyalty_type"
                    :items="loyaltyTypeOptions"
                    dense
                    outlined
                    hide-details="auto"
                    placeholder="Select Loyalty Type"
                    :disabled="auditorDisabled || voidRequestDisabled || isApprovedRequest"
                  ></v-select>
                  <RequestHint
                    v-if="request && request.loyalty_type && !isApprovedRequest"
                    :is-attr-change="loyalty.loyalty_type !== request.loyalty_type"
                    :is-auditor-respond="auditorDisabled"
                    :is-request-void="isRequestVoid"
                    :hint="request.loyalty_type"
                  />
                </v-col>
              </v-row>
              <v-row>
                <!-- Name -->
                <v-col
                  cols="12"
                  sm="6"
                  :class="{ 'pl-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                  class="offset-sm-0"
                >
                  <p class="font-weight-semibold">
                    Customer Name:
                  </p>
                  <v-text-field
                    v-model="loyalty.name"
                    single-line
                    dense
                    outlined
                    hide-details
                    placeholder="Customer Name"
                    :disabled="auditorDisabled || voidRequestDisabled || isApprovedRequest"
                  ></v-text-field>
                  <RequestHint
                    v-if="request && !isApprovedRequest"
                    :is-attr-change="loyalty.name !== request.name"
                    :is-auditor-respond="auditorDisabled"
                    :is-request-void="isRequestVoid"
                    :hint="request.name"
                  />
                </v-col>

                <!-- Contact Number -->
                <v-col
                  cols="12"
                  sm="6"
                  :class="{ 'pr-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                >
                  <p class="font-weight-semibold">
                    Contact No.:
                  </p>
                  <v-text-field
                    v-model="loyalty.contact_number"
                    single-line
                    dense
                    outlined
                    type="number"
                    :rules="[v => /[0-9\-().\s]{7}$/.test(v) || 'Must be valid contact number']"
                    hide-details="auto"
                    placeholder="Contact Number"
                    prefix="+673"
                    :disabled="auditorDisabled || voidRequestDisabled || isApprovedRequest"
                    @mousewheel.native.prevent
                  ></v-text-field>
                  <RequestHint
                    v-if="request && !isApprovedRequest"
                    :is-attr-change="loyalty.contact_number !== request.contact_number"
                    :is-auditor-respond="auditorDisabled"
                    :is-request-void="isRequestVoid"
                    :hint="request.contact_number"
                  />
                </v-col>

                <!-- IC Number -->
                <v-col
                  cols="12"
                  sm="6"
                  :class="{ 'pl-0 mb-6 mb-sm-0': $vuetify.breakpoint.smAndUp, 'px-0': $vuetify.breakpoint.xsOnly }"
                >
                  <p class="font-weight-semibold">
                    IC No.:
                  </p>
                  <v-text-field
                    v-model="loyalty.ic_number"
                    single-line
                    dense
                    outlined
                    hide-details="auto"
                    placeholder="IC Number"
                    :disabled="auditorDisabled || voidRequestDisabled || isApprovedRequest"
                  ></v-text-field>
                  <RequestHint
                    v-if="request && !isApprovedRequest"
                    :is-attr-change="loyalty.ic_number !== request.ic_number"
                    :is-auditor-respond="auditorDisabled"
                    :is-request-void="isRequestVoid"
                    :hint="request.ic_number"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      md="3"
    >
      <v-card
        v-if="!isApprovedRequest"
        class="mb-6"
      >
        <v-card-text>
          <!-- Auditor view request -->
          <v-btn
            v-if="can('write', 'ReportActions') && requestId"
            color="primary"
            block
            depressed
            :disabled="isRespondedRequest || loyalty.deleted_at"
            class="mb-2"
            @click="isApproveDialogVisible = true"
          >
            {{ t('Approve Request') }}
          </v-btn>

          <!-- Auditor view request -->
          <v-btn
            v-if="can('write', 'ReportActions') && requestId"
            color="primary"
            outlined
            depressed
            block
            :disabled="isRespondedRequest"
            @click="isRejectDialogVisible = true"
          >
            {{ t('Reject Request') }}
          </v-btn>

          <!-- Create & edit receipt -->
          <v-btn
            v-else-if="can('write', 'ReportActions') && userRole === 'Auditor'"
            color="primary"
            depressed
            block
            :loading="loading"
            :disabled="loading"
            @click="roleUpdate('auditor')"
          >
            {{ t('Confirm Loyalty') }}
          </v-btn>

          <!-- Void request -->
          <v-btn
            v-else-if="router.currentRoute.params.action === 'Void' || loyalty.deleted_at"
            color="error"
            depressed
            block
            :disabled="isApprovedRequest"
            @click="isVoidDialogVisible = true"
          >
            {{ t('Remove Request') }}
          </v-btn>

          <!-- Create & edit request -->
          <v-btn
            v-else
            color="primary"
            depressed
            block
            :disabled="isApprovedRequest"
            @click="isCommentDialogVisible = true"
          >
            {{ t('Send Request') }}
          </v-btn>

          <div
            v-if="loyalty.deleted_at"
            class="text-center mt-4"
          >
            {{ can('write', 'ReportActions') ? t('Niagamas Loyalty has been voided, please inform requester to remove this request.')
              : t('Niagamas Loyalty has been voided, please remove this request as it cannot be saved.') }}
          </div>

          <div
            v-else-if="!auditorDisabled && router.currentRoute.params.action !== 'Void'"
            class="text-center mt-4"
          >
            {{ t('Please ensure that all fields are filled correctly as this record will not be editable after confirming.') }}
          </div>
        </v-card-text>
      </v-card>
      <v-card
        v-if="errors.length != 0"
        class="mb-6"
      >
        <v-card-text>
          <Alert
            :messages="errors"
            color="error"
          ></Alert>
        </v-card-text>
      </v-card>
      <v-card
        v-if="requestId && !isApprovedRequest && can('write', 'ReportActions')"
        class="mb-6"
      >
        <v-card-text v-if="request.requested_by">
          <div v-if="isRequestVoid">
            {{ request.requested_by.nickname }} has requested to void this niagamas loyalty.
          </div>
          <div v-else-if="isRequestCreate">
            {{ request.requested_by.nickname }} has requested to create this niagamas loyalty.
          </div>
          <div v-else>
            <div class="mb-2">
              {{ request.requested_by.nickname }} has requested to edit this niagamas loyalty.
            </div>
            <div>The <span class="primary--text font-weight-semibold">requested changes</span> is hinted below each niagamas loyalty field, ensure these changes are appropriate as this niagamas loyalty will not be reversible after approval.</div>
          </div>
        </v-card-text>
      </v-card>
      <v-card
        v-if="isApprovedRequest"
        class="mb-6"
      >
        <v-card-text>
          <div>
            This request has been approved & no longer editable.
          </div>
        </v-card-text>
      </v-card>
      <RequestComments
        v-if="requestId"
        :comments="comments"
        :fetch-comments="fetchComments"
      />
    </v-col>

    <!-- Void dialog -->
    <v-dialog
      v-model="isVoidDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title class="d-flex align-center mv-4">
          Void request on {{ request.record_number || loyalty.name }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isVoidDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          This request will be voided. It won't be taken into any calculations.
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="error"
            block
            :loading="voidLoading"
            :disabled="voidLoading"
            class="mt-3"
            @click="voidRequest()"
          >
            Yes, remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Comment dialog -->
    <v-dialog
      v-model="isCommentDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title class="d-flex align-center mv-4">
          Request changes?
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isCommentDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-textarea
            v-model="newComment"
            dense
            outlined
            hide-details="auto"
            placeholder="Leave your comment here (optional)"
            :disabled="loading"
            class="mb-4"
          ></v-textarea>
          <p>
            {{ requestId ? 'This updates the edit request & changes status to Pending for auditor to respond.' :
              'This action will create an edit request & the changes will be saved after approved by auditor.' }}
          </p>
          <p class="mb-0">
            Please leave any remarks that the auditor should know about the changes.
          </p>
        </v-card-text>

        <v-card-actions class="mt-2">
          <v-btn
            color="primary"
            block
            :loading="loading"
            :disabled="loading"
            @click="roleUpdate('clerk')"
          >
            Yes, send request
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approve dialog -->
    <v-dialog
      v-model="isApproveDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title class="d-flex align-center mv-4">
          Approve request
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isApproveDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="newComment"
            dense
            outlined
            hide-details="auto"
            placeholder="Leave your comment here (optional)"
            :disabled="loading"
            class="mb-1"
          ></v-text-field>
          This action will update niagamas loyalty with the request changes, ensure that all fields are filled correctly as this record will not be editable after approval.
        </v-card-text>

        <v-card-actions class="mt-2">
          <v-btn
            color="primary"
            block
            :loading="loading"
            :disabled="loading"
            @click="approveRequest()"
          >
            Save niagamas loyalty
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Reject dialog -->
    <v-dialog
      v-model="isRejectDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title class="d-flex align-center mv-4">
          Reject request
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isRejectDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="newComment"
            dense
            outlined
            hide-details="auto"
            placeholder="Leave your comment here (optional)"
            :disabled="loading"
            class="mb-1"
          ></v-text-field>
          This update the request & change status to Rejected, comment on the reason for rejecting the requested change.
        </v-card-text>

        <v-card-actions class="mt-2">
          <v-btn
            color="primary"
            block
            :loading="loading"
            :disabled="loading"
            @click="rejectRequest()"
          >
            Reject request
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mdiCalendar, mdiPaperclip } from '@mdi/js'
import {
  inject,
  onMounted,
  ref,
} from '@vue/composition-api'
import { useRouter } from '@core/utils'
import Alert from '@/components/Alert'
import RequestHint from '@/components/apps/request/RequestHint'
import RequestComments from '@/components/apps/request/RequestComments'

export default {
  components: {
    Alert,
    RequestHint,
    RequestComments,
  },
  setup() {
    // Initializers
    const store = inject('store')
    const snackbarService = inject('snackbarService')
    const t = inject('t')
    const can = inject('can')
    const { router } = useRouter()
    const requestId = router.currentRoute.params.request_id

    // Properties
    const loyalty = ref({
      registration_date: new Date().toISOString().substring(0, 10),
      name: null,
      contact_number: null,
      ic_number: null,
      loyalty_type: null,
    })
    const loyaltyTypeOptions = ref([])
    const request = ref({})
    const comments = ref([])
    const errors = ref([])
    const userData = JSON.parse(localStorage.getItem('userData'))
    const userRole = userData && userData.role ? userData.role : null
    const dateToday = new Date().toLocaleDateString('en-SG')
    const loading = ref(false)
    const voidLoading = ref(false)
    const auditorDisabled = ref(false)
    const voidRequestDisabled = ref(false)
    const isVoidDialogVisible = ref(false)
    const isApproveDialogVisible = ref(false)
    const isRejectDialogVisible = ref(false)
    const isRequestVoid = ref(false)
    const isRequestCreate = ref(false)
    const isApprovedRequest = ref(false)
    const isRespondedRequest = ref(false)
    const isDateMenuOpen = ref(false)
    const isCommentDialogVisible = ref(false)
    const newComment = ref(null)

    // Methods
    const fetchRequest = () => {
      store
        .dispatch('requestStore/fetchRequest', { id: requestId })
        .then(response => {
          let loyaltyAttrsInField = response.data.data.record
          if (response.data.data.approved_at) {
            isApprovedRequest.value = true
            loyaltyAttrsInField = response.data.data.result
          }
          const existingLoyalty = loyaltyAttrsInField
          loyalty.value.id = response.data.data.record.id
          loyalty.value.created_at = existingLoyalty.created_at
          loyalty.value.name = existingLoyalty.name
          loyalty.value.ic_number = existingLoyalty.ic_number
          loyalty.value.contact_number = existingLoyalty.contact_number
          loyalty.value.loyalty_type = existingLoyalty.loyalty_type
          loyalty.value.registration_date = new Date(existingLoyalty.registration_date.replace(/(..)\/(..)\/(....)/, '$3-$2-$1')).toISOString().substring(0, 10)
          if (response.data.data.result) {
            request.value = response.data.data.result
            request.value.registration_date = new Date(request.value.registration_date.replace(/(..)\/(..)\/(....)/, '$3-$2-$1')).toISOString().substring(0, 10)
          }
          request.value.requested_by = response.data.data.requested_by
          request.value.responded_by = response.data.data.responded_by
          request.value.record_number = response.data.data.record.receipt_number
          request.value.requested_at = response.data.data.requested_at
          isRequestVoid.value = response.data.data.action === 'Void'
          isRequestCreate.value = response.data.data.action === 'Create'
          if (response.data.data.responded_by) isRespondedRequest.value = true
          if (response.data.data.approved_at) isApprovedRequest.value = true
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching request. Please refresh!')
        })
    }
    const fetchRequestedLoyalty = () => {
      store
        .dispatch('requestStore/fetchRequest', { id: requestId })
        .then(response => {
          const returnedLoyalty = response.data.data.result

          loyalty.value.id = response.data.data.record.id
          loyalty.value.created_at = returnedLoyalty.created_at
          loyalty.value.name = returnedLoyalty.name
          loyalty.value.ic_number = returnedLoyalty.ic_number
          loyalty.value.contact_number = returnedLoyalty.contact_number
          loyalty.value.loyalty_type = returnedLoyalty.loyalty_type
          loyalty.value.registration_date = new Date(returnedLoyalty.registration_date.replace(/(..)\/(..)\/(....)/, '$3-$2-$1')).toISOString().substring(0, 10)
          if (response.data.data.approved_at) isApprovedRequest.value = true
          loyalty.value.deleted_at = returnedLoyalty.deleted_at
          isRequestCreate.value = response.data.data.action === 'Create'
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching request. Please refresh!')
        })
    }
    const fetchLoyalty = () => {
      store
        .dispatch('customerStore/fetchNiagamasLoyalty', { id: router.currentRoute.params.id })
        .then(response => {
          const existingLoyalty = response.data.data

          loyalty.value.id = existingLoyalty.id
          loyalty.value.name = existingLoyalty.name
          loyalty.value.contact_number = existingLoyalty.contact_number
          loyalty.value.ic_number = existingLoyalty.ic_number
          loyalty.value.loyalty_type = existingLoyalty.loyalty_type
          loyalty.value.registration_date = new Date(existingLoyalty.registration_date.replace(/(..)\/(..)\/(....)/, '$3-$2-$1')).toISOString().substring(0, 10)
        })
        .catch(error => {
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching niagamas loyalty. Please refresh!')
        })
    }
    const updateLoyalty = () => {
      const updateParam = {
        id: router.currentRoute.params.id,
        niagamas_loyalty: loyalty.value,
      }
      store
        .dispatch('customerStore/updateNiagamasLoyalty', updateParam)
        .then(response => {
          loading.value = false
          snackbarService.success(response.data.message)
          router.push('/apps/profile-creation/list')
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while updating niagamas loyalty. Please refresh!')
        })
    }
    const saveRequest = () => {
      loading.value = true
      const requestParam = {
        record_id: loyalty.value.id,
        record_type: 'NiagamasLoyalty',
        requested_by_id: userData.id,
        action: isRequestCreate.value ? 'Create' : 'Edit',
        params: loyalty.value,
        rejected_at: null,
        responded_by: null,
        comment: newComment.value,
      }
      if (requestId) requestParam.id = requestId

      store
        .dispatch(`requestStore/${requestId ? 'updateRequest' : 'createRequest'}`, requestParam)
        .then(response => {
          snackbarService.success(response.data.message)
          router.push('/apps/requests/list')
        })
        .catch(error => {
          loading.value = false
          isCommentDialogVisible.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while saving request. Please refresh!')
        })
    }
    const approveRequest = () => {
      loading.value = true
      store
        .dispatch('requestStore/approveRequest', { id: requestId, comment: newComment.value })
        .then(response => {
          snackbarService.success(response.data.message)
          router.push('/apps/requests/list')
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while approving request. Please refresh!')
        })
    }
    const rejectRequest = () => {
      loading.value = true
      store
        .dispatch('requestStore/rejectRequest', { id: requestId, comment: newComment.value })
        .then(response => {
          snackbarService.success(response.data.message)
          router.push('/apps/requests/list')
        })
        .catch(error => {
          loading.value = false
          errors.value = error.response.data.errors
          snackbarService.error(error.response.data.message || 'Something went wrong while rejecting request. Please refresh!')
        })
    }
    const voidRequest = () => {
      voidLoading.value = true
      store
        .dispatch('requestStore/voidRequest', { id: requestId })
        .then(response => {
          snackbarService.success(response.data.message)
          router.push('/apps/requests/list')
        })
        .catch(error => {
          voidLoading.value = false
          snackbarService.error(error.data.message || 'Something went wrong while voiding request. Please refresh!')
        })
    }
    const isNumber = event => {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const keyPressed = event.key
      if (!keysAllowed.includes(keyPressed)) {
        event.preventDefault()
      }
    }
    const roleUpdate = role => {
      if (role === 'auditor') {
        updateLoyalty()
      } else if (role === 'clerk') {
        saveRequest()
      }
    }
    const fetchComments = () => {
      store
        .dispatch('requestStore/fetchComments', { request_id: requestId })
        .then(response => {
          const { data } = response.data
          comments.value = data
        })
        .catch(error => {
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching comments. Please refresh!')
        })
    }
    const fetchLoyaltyTypes = () => {
      store
        .dispatch('customerStore/fetchLoyaltyTypes')
        .then(response => {
          const { data } = response.data
          loyaltyTypeOptions.value = data
        })
        .catch(error => {
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching loyalty types. Please refresh!')
        })
    }
    const isLoyaltyEdit = () => {
      if (requestId && can('write', 'ReportActions')) {
        // Auditor view request
        auditorDisabled.value = true
        fetchRequest()
      } else if (router.currentRoute.params.action === 'Void') {
        voidRequestDisabled.value = true
        fetchRequest()
      } else if (requestId) {
        // Clerk edit request
        fetchRequestedLoyalty()
      } else {
        // Edit invoice / create request
        fetchLoyalty()
      }
    }

    // Mounted
    onMounted(() => {
      if (requestId) fetchComments()
      isLoyaltyEdit()
      fetchLoyaltyTypes()
    })

    return {
      t,
      can,
      router,
      loyalty,
      request,
      requestId,
      comments,
      errors,
      fetchRequest,
      fetchRequestedLoyalty,
      saveRequest,
      voidRequest,
      approveRequest,
      rejectRequest,
      userData,
      dateToday,
      loading,
      isNumber,
      isDateMenuOpen,
      isCommentDialogVisible,
      isVoidDialogVisible,
      isApproveDialogVisible,
      isRejectDialogVisible,
      newComment,
      fetchComments,
      fetchLoyalty,
      updateLoyalty,
      auditorDisabled,
      voidRequestDisabled,
      isApprovedRequest,
      isRespondedRequest,
      isRequestVoid,
      isRequestCreate,
      voidLoading,
      roleUpdate,
      loyaltyTypeOptions,
      userRole,

      icons: {
        mdiCalendar,
        mdiPaperclip,
      },
    }
  },
}
</script>
